import fileDownload from 'js-file-download';
import Axios from 'axios';

function downloadFileByUrl(filename, dataUrl){
    Axios.get(dataUrl, {
        responseType: 'blob',
    }).then(res => {
        fileDownload(res.data, filename);
    });
}

export default downloadFileByUrl;